<template>
  <div>
    <protocol-header v-if="protocol" :protocol="protocol"></protocol-header>
    
    <div class="row">
      <div class="col-12">
        <form id="frm-evaluation"
              ref="frm-evaluation"
              accept-charset="UTF-8"
              class="card"
              method="GET"
              onsubmit="return false">
          <div class="card-header">
            <h1 class="card-title mb-0">{{ task.classification.title }}</h1>
          </div>
          
          <div class="card-body">
            <div class="form-group">
              
              <label class="d-block font-weight-normal"
                     for="status">Validado:
              </label>
              <input type="text"
                     name="status"
                     id="status"
                     :value="task.parameters ? task.parameters.evaluation.status === 'rechazado' ? 'No' : 'Si' : null"
                     class="form-control"
                     disabled/>
            </div>
            
            <div class="form-group">
              
              <label class="d-block font-weight-normal"
                     for="evaluation_date">Fecha de evaluación:
              </label>
              <input type="text"
                     name="status"
                     id="evaluation_date"
                     :value="evaluationDate"
                     class="form-control"
                     disabled/>
            </div>
            
            <div class="form-group">
              <label class="d-block font-weight-normal"
                     for="comments">Observaciones:
                <abbr style="text-decoration: none;"
                      title="Campo obligatorio">*</abbr>
              </label>
              <textarea id="comments"
                        v-model="task.parameters.evaluation.comments"
                        class="form-control"
                        name="comments"
                        placeholder="Ingrese sus observaciones..."
                        rows="3"
                        disabled
                        ref="comments"></textarea>
            </div>
            
            <div class="form-group">
              <button type="button"
                      class="btn btn-primary btn-lg"
                      @click="editProtocol">
                <spinner small class="text-white"
                         v-if="sending"
                         :disabled="sending"></spinner>
                Editar protocolo
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
  import ProtocolHeader from './ProtocolHeader'
  import autosize from 'autosize'
  import moment from 'moment'
  import Spinner from '../ui/Spinner'
  
  export default {
    name: 'ProtocolEvaluation',
    components: {
      Spinner,
      ProtocolHeader,
    },
    props: {
      user: Object,
      protocol: Object,
      task: Object,
    },
    data: () => ({
      sending: false,
    }),
    methods: {
      editProtocol () {
        this.sending = true
        
        location.href = `/protocolo/${this.protocol.id}`
      },
    },
    computed: {
      evaluationDate () {
        return moment(this.task.parameters.evaluation.created_at).format('DD/MM/YYYY')
      },
    },
    mounted () {
      autosize(document.getElementById('comments'))
    },
  }
</script>
